/**
 * Remi - AI Billing Assistant.
 *
 * Public surface of this feature is exactly one component. Everything else in
 * this folder is private to it, and nothing in this folder imports from
 * ../../pages or ../../components - that isolation is what lets the widget be
 * lifted into its own Vite bundle later without a rewrite.
 *
 * The exported component is wrapped in an error boundary. RemiWidget renders on every
 * authenticated screen, so without it an unhandled render error would blank the whole
 * portal rather than just the assistant. Import from here, not from ./RemiWidget.
 *
 * See docs/ai-assistant/BACKEND-CONTRACT.md for the service it talks to.
 */
import React from "react";
import RemiWidgetInner from "./RemiWidget";
import RemiErrorBoundary from "./RemiErrorBoundary";

function RemiWidget(props) {
  return (
    <RemiErrorBoundary>
      <RemiWidgetInner {...props} />
    </RemiErrorBoundary>
  );
}

export { RemiWidget };
export default RemiWidget;
